import { Injectable } from '@angular/core';
import { PollingResourceConfig } from '@grid-ui/common';
import { select, Store } from '@ngrx/store';
import { continueOngoingPoll, startPolling, userCancel } from '../store/actions/polling.actions';
import * as fromPolling from '../store/reducers';

import { PollConfig, PollItem, PollStatusEnum } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PollingService {
  constructor(private readonly store: Store<fromPolling.State>) {}

  public start(apiConfig: PollingResourceConfig, requestBody: any): PollItem {
    const id = Date.now();
    const poll: PollConfig = {
      apiConfig,
      id,
      pollCount: 0,
      requestBody,
      status: PollStatusEnum.NotStarted,
    };

    this.store.dispatch(startPolling({ poll }));
    const poll$ = this.store.pipe(select(fromPolling.selectPollById(id)));
    return { id, poll$ };
  }

  public cancel(id: number): void {
    this.store.dispatch(userCancel({ id }));
  }

  public continueOngoingPoll(apiConfig: PollingResourceConfig, pollServerId: number): PollItem {
    const id = Date.now();
    const poll: PollConfig = {
      apiConfig,
      id,
      serverPollingSessionId: pollServerId,
      pollCount: 0,
      requestBody: null,
      status: PollStatusEnum.Active,
    };

    this.store.dispatch(continueOngoingPoll({ poll }));
    const poll$ = this.store.pipe(select(fromPolling.selectPollById(id)));
    return { id, poll$ };
  }
}
